import React, { useEffect, useState } from 'react'
import TableRow from '@mui/material/TableRow'
import { Box, Typography } from '@mui/material'
import PropTypes from 'prop-types'
import Table from '@mui/material/Table'
import TableBody from '@mui/material/TableBody'
import TableContainer from '@mui/material/TableContainer'
import TableHead from '@mui/material/TableHead'
import { useDispatch, useSelector } from 'react-redux'
import config from '../../config/config'
import {
  PEDESTRIAN_FACILITY_TYPE,
  PEDESTRIAN_FACILITY_TYPE_VALUES
} from '../../constants/pedestrian'
import {
  BIKE_FACILITY_TYPE,
  BIKE_FACILITY_TYPE_VALUES
} from '../../constants/bike'
import { setSafetyMeasures } from '../../slices/safetyMeasures'
import {
  StyledTableHeadingCell,
  StyledTableCell,
  StyledTableRow
} from './ScoringSummary'
import { NO } from '../../constants/roadwayVariables'

export default function SafetyCounterMeasures() {
  const counterMeasuresField = ['Countermeasures', 'Mode', 'Implemented']
  const { safetyMeasuresArr } = useSelector((state) => state.safetyMeasures)
  return (
    <Box>
      <Typography
        variant="h2"
        sx={{ marginBottom: 2, color: config.themeConfig.contrastColor }}
      >
        FHWA Proven Safety Countermeasures Implemented in Your Project
      </Typography>
      <TableContainer>
        <Table aria-label="simple table">
          <TableHead>
            <TableRow>
              {counterMeasuresField.map((field) => (
                <StyledTableHeadingCell
                  key={`${field}-header`}
                  sx={
                    field !== 'Countermeasures' ? { textAlign: 'center' } : {}
                  }
                >
                  {field}
                </StyledTableHeadingCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {config.counterMeasuresConfig.map((counterMeasure) => (
              <CustomTableRow
                key={`${counterMeasure.name}-tablerow`}
                counterMeasure={counterMeasure}
              />
            ))}
            <StyledTableRow
              sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
            >
              <StyledTableCell component="th" scope="row">
                Total number of countermeasures implemented
              </StyledTableCell>
              <StyledTableCell
                component="th"
                scope="row"
                sx={{ textTransform: 'capitalize', textAlign: 'center' }}
              />
              <StyledTableCell align="center">
                {' '}
                {safetyMeasuresArr.reduce(
                  (sum, measure) =>
                    measure.isMeasureImplemented ? sum + 1 : sum,
                  0
                )}{' '}
              </StyledTableCell>
            </StyledTableRow>
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  )
}
function CustomTableRow({ counterMeasure }) {
  const safetyMeasureValues = useSelector(
    (state) => state[counterMeasure.mode][counterMeasure.id]
  )
  const [isMeasureImplemented, setIsMeasureImplemented] = useState(
    safetyMeasureValues.includes(counterMeasure.alias)
  )
  const dispatch = useDispatch()

  const pedestrianSafetyValue = useSelector(
    (state) => state.pedestrian.pedestrian_facility_type
  )
  const bikeSafetyValue = useSelector(
    (state) => state.bicycle.bike_facility_type
  )

  const autoSafetyValue = useSelector(
    (state) => state.auto.lane_repurposing_planned
  )

  useEffect(() => {
    if (counterMeasure.id === PEDESTRIAN_FACILITY_TYPE) {
      setIsMeasureImplemented(
        pedestrianSafetyValue &&
          pedestrianSafetyValue !== PEDESTRIAN_FACILITY_TYPE_VALUES[2]
      )

      dispatch(
        setSafetyMeasures({
          name: counterMeasure.name,
          id: counterMeasure.id,
          mode: counterMeasure.mode,
          isMeasureImplemented:
            pedestrianSafetyValue &&
            pedestrianSafetyValue !== PEDESTRIAN_FACILITY_TYPE_VALUES[2]
        })
      )
    } else if (counterMeasure.id === BIKE_FACILITY_TYPE) {
      setIsMeasureImplemented(
        bikeSafetyValue && bikeSafetyValue !== BIKE_FACILITY_TYPE_VALUES[0]
      )
      dispatch(
        setSafetyMeasures({
          name: counterMeasure.name,
          id: counterMeasure.id,
          mode: counterMeasure.mode,
          isMeasureImplemented:
            bikeSafetyValue && bikeSafetyValue !== BIKE_FACILITY_TYPE_VALUES[0]
        })
      )
    } else if (counterMeasure.id === 'lane_repurposing_planned') {
      setIsMeasureImplemented(autoSafetyValue && autoSafetyValue !== NO)
      dispatch(
        setSafetyMeasures({
          name: counterMeasure.name,
          id: counterMeasure.id,
          mode: counterMeasure.mode,
          isMeasureImplemented: autoSafetyValue && autoSafetyValue !== NO
        })
      )
    } else {
      // setIsMeasureImplemented(
      //   safetyMeasureValues.includes(counterMeasure.alias)
      // )
      dispatch(
        setSafetyMeasures({
          name: counterMeasure.name,
          id: counterMeasure.id,
          mode: counterMeasure.mode,
          isMeasureImplemented: safetyMeasureValues.includes(
            counterMeasure.alias
          )
        })
      )
    }
  }, [counterMeasure, safetyMeasureValues])

  return (
    <StyledTableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
      <StyledTableCell component="th" scope="row">
        {counterMeasure?.name}
      </StyledTableCell>
      <StyledTableCell
        component="th"
        scope="row"
        sx={{ textTransform: 'capitalize', textAlign: 'center' }}
      >
        {counterMeasure?.mode}
      </StyledTableCell>
      <StyledTableCell align="center">
        {isMeasureImplemented ? 'YES' : 'NO'}
      </StyledTableCell>
    </StyledTableRow>
  )
}

CustomTableRow.propTypes = {
  counterMeasure: PropTypes.object.isRequired
}
